module.exports = __webpack_public_path__ + "img/eswatini.609860b2.svg";